module.exports = __webpack_public_path__ + "static/media/Niveau_elN14_3_690740.ad1eb986.png";